(() => {
  if (customElements.get('dlt-instagram-rail')) return;
  customElements.define('dlt-instagram-rail', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const track = this.querySelector('.dlt-instagram__track');
      const previous = this.querySelector('[data-instagram-prev]');
      const next = this.querySelector('[data-instagram-next]');
      this.querySelector('.dlt-instagram__navigation').hidden = false;
      const update = () => {
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = direction => track.scrollBy({left: direction * (track.firstElementChild.getBoundingClientRect().width + 20), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      previous.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      track.addEventListener('scroll', () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(update); }, {signal, passive:true});
      this.resize = new ResizeObserver(update);
      this.resize.observe(track);
      const load = button => {
        if (!button.isConnected) return;
        const iframe = document.createElement('iframe');
        const url = new URL(button.dataset.instagramEmbed);
        if (url.origin !== 'https://www.instagram.com' || !/^\/(p|reel)\/[A-Za-z0-9_-]+\/embed\/$/.test(url.pathname)) return;
        iframe.src = url.href;
        iframe.title = button.dataset.instagramTitle || 'Publicação oficial De La Terre';
        iframe.loading = 'lazy';
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.allowFullscreen = true;
        button.closest('[data-instagram-media]').replaceChildren(iframe);
      };
      this.querySelectorAll('[data-instagram-embed]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => load(button), {signal});
      });
      if ('IntersectionObserver' in window) {
        this.cards = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const button = entry.target.querySelector('[data-instagram-embed]');
          if (button) load(button);
          this.cards.unobserve(entry.target);
        }), {root:track, threshold:.15});
        this.visibility = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.visibility.disconnect();
          this.querySelectorAll('.dlt-instagram__card').forEach(card => this.cards.observe(card));
        }, {threshold:.05});
        this.visibility.observe(this);
      }
      update();
    }
    disconnectedCallback() { this.controller?.abort(); this.resize?.disconnect(); this.visibility?.disconnect(); this.cards?.disconnect(); cancelAnimationFrame(this.frame); }
  });
})();
